export default "__VITE_ASSET__4310b50b__"